module.exports = __webpack_public_path__ + "img/d-9.5dca0601.png";